import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import GoalLeadInfo from './icon-goal-lead-info.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <GoalLeadInfo {...validProps} />;
}
SvgComponent.iconName = 'goal-lead-info';

/**
 * @deprecated This is a legacy icon
 */
export const GoalLeadInfoIcon = svgIconWrapper(SvgComponent);
